import { createFileRoute, redirect } from '@tanstack/react-router'

import { LABELS, MENU } from '@/constants/common/message.constants'
import { fetchAreas } from '@/features/areas/api'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/tour/create'
)({
  meta: () => [
    { title: `${MENU.NEW_REGISTRATION}（${LABELS.CONTRACT_TYPE_UNKOU_DATE}）` }
  ],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合は契約一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/contracts`
      })
    }
  },
  loader: async ({ params: { tenantKey }, abortController }) => {
    const areaSelectList = await fetchAreas(
      { tenantKey },
      abortController.signal
    )
    return {
      areaSelectList
    }
  }
})
